module.exports = __webpack_public_path__ + "static/media/green.25b925e9.png";